import React, { createContext, useContext } from 'react';
import { useSnackbar } from './SnackbarContext';
import { useTranslation } from './TranslationContext';

const ErrorContext = createContext();

export const ErrorProvider = ({ children }) => {
  const { openSnackbar } = useSnackbar();
  const {translate} = useTranslation()
  const handleError = (error, errorMessage = translate("errorContext.tryLater")) => {
    console.error('An error occurred:', error);
    setTimeout(() => {
      openSnackbar('error', errorMessage);
    }, 500);
  };

  return (
    <ErrorContext.Provider value={{ handleError }}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  return useContext(ErrorContext);
};

export { ErrorContext };
